import React, { Component, Fragment } from 'react'
import qs from 'qs'
class NoResults extends Component {

  resetLinkStyle = {
    color: "#009BBF",
    cursor: "pointer"
  }


  hasFilters = () => {
    const search = window.location.href.split("?")[1]
    return !!qs.parse(search).filters
  }

  render() {
    return (
      <Fragment>
        {
          this.props.app === "ELSS"
          ?
          <h3 className="no-result-your-search">Your search for - <b>{this.props.q}</b> - has no results in e-LAB Solutions Suite.</h3>
          :
          <h3 className="no-result-your-search">Your search: <b>{this.props.q}</b> -  did not match any documents.</h3>
        }
        <p className="no-result-suggestions">
        Suggestions:
        <br />
          &nbsp; - Make sure all words are spelled correctly. <br />
          &nbsp; - Try different keywords. <br />
          &nbsp; - Try more general keywords. <br />
          &nbsp; - Try fewer keywords. <br />
          {
            this.props.app === "ELSS"
            &&
            this.hasFilters()
            &&
            <Fragment>
              &nbsp; - <a style={this.resetLinkStyle} onClick={this.props.resetFilters}>Search - {this.props.q} - across all of CAP web properties</a> <br />
            </Fragment>
          }
        </p>
      </Fragment>
    )
  }
}

export default NoResults